import React from 'react';
import { ApiButton, Box, ErrorStateInfo, Typography } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import {typeTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  labelContainer: {
    '& img': {
      width: 45,
      height: 45,
    },
  },
  label: {
     ...typeTheme(theme, 'body1bold'),
  },
}));

const ErrorFileLabel = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Box className={classes.labelContainer}>
      <ErrorStateInfo>
        <Typography variant="body1" className={classes.label}>
          {t('components->>ErrorFile.FileProcessingUnsuccessful')}
        </Typography>
      </ErrorStateInfo>
    </Box>
  );
};

interface DownloadErroFileButtonProps {
  onActionButtonClicked: () => void;
}

const DownloadErrorFileButton = ({ onActionButtonClicked }: DownloadErroFileButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <ApiButton id='button-download-error-file' variant="text" status="idle" onClick={onActionButtonClicked} color="primary">
        <IconWithLabel
          iconName={IconName.download}
          iconSize="L"
          label={t('components->>ErrorFile.DownloadErrorFile')}
          typographyProps={{
            variant: 'h5',
            color: 'inherit',
          }}
        />
      </ApiButton>
    </Box>
  );
};

export { ErrorFileLabel, DownloadErrorFileButton };
